import { z } from 'zod';
import { BaseElementSchema } from '@/components/canvas/document/schema/elementBase';

export const GroupElementSchema = BaseElementSchema.extend({
  type: z.literal('group'),
  data: z.object({
    children: z.array(z.string()).default([]),
  }),
});
